export const getPhoneNumber = (value) => {
    if (!value?.phone) return ''
    return `${value.phone}`.trim()
}
